import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { throwError, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { checkList, CheckListImagesResponse, ConfigCheckListImagesResponse } from '../models/checkList.model';
import { delayedRetryHttp } from '../shared/delayedRetry';
import { UtilityService } from './shared/utility.service';

@Injectable()
export class CheckListService {
  private baseUrl: string; // = "https://localhost:44353/api/officesetup";
  private api: string = "api/CheckList";

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') _baseUrl: string, private _utilityService: UtilityService) {
    this.baseUrl = _baseUrl + this.api;
  }

  private handleErrors(errorResponse: HttpErrorResponse) {
    if (errorResponse.error instanceof ErrorEvent) {
      console.error('Check list Service Client Side Error: ', errorResponse.error.message);
    } else {
      console.error('Check list Service Server Side Error: ', errorResponse);
    }

    return throwError("There is a problem with the service. We are notified & working on it. Please try again later.");
  }

  getCheckList(contractSessionId: number, encryptedUser: string): Observable<CheckListImagesResponse> {
    return this.httpClient
      .get<CheckListImagesResponse>(`${this.baseUrl}/GetCheckList/${contractSessionId}`, {
        headers: new HttpHeaders({
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp(10000), catchError(err => { return this._utilityService.handleErrors(err, null, "contractSessionId - " + contractSessionId, "CheckListService", "getMediaDocList"); }));

  }

  DeleteCheckListByID(mediaID: number, contractSessionId: number, encryptedUser: string): Observable<CheckListImagesResponse> {
    return this.httpClient      
      .get<CheckListImagesResponse>(`${this.baseUrl}/DeleteCheckListByID/${mediaID}/${contractSessionId}`, {
        headers: new HttpHeaders({
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp(10000), catchError(err => { return this._utilityService.handleErrors(err, null, "mediaID - " + mediaID + " inventionId - " + contractSessionId, "CheckListService", "DeleteCheckListByID"); }));
  }

  getConfigCheckList(encryptedUser: string): Observable<ConfigCheckListImagesResponse> {
    return this.httpClient
      .get<ConfigCheckListImagesResponse>(`${this.baseUrl}/GetConfigCheckList`, {
        headers: new HttpHeaders({
          'Authorization': 'Basic ' + encryptedUser
        })
      }).pipe(delayedRetryHttp(10000), catchError(err => { return this._utilityService.handleErrors(err, null, "CheckListService", "getConfigCheckList"); }));

  }

}



